import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import type { CategoryFilter } from '@/api/publicAnnouncements'

interface AnnouncementCategoryFilterProps {
  value: CategoryFilter
  onChange: (next: CategoryFilter) => void
}

const ORDER: CategoryFilter[] = ['all', 'pinned', 'normal']

export function AnnouncementCategoryFilter({
  value,
  onChange,
}: AnnouncementCategoryFilterProps) {
  const { t } = useTranslation('announcements')

  return (
    <div
      className="flex items-center gap-2"
      role="tablist"
      aria-label={t('filter.all')}
    >
      {ORDER.map((key) => {
        const active = value === key
        return (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(key)}
            className={cn(
              'rounded-full font-medium tracking-[-0.6px] text-center transition-colors',
              'px-4 py-1.5 text-sm w-14',
              'lg:py-2 lg:text-base lg:w-auto lg:min-w-[96px]',
              active
                ? 'bg-[#4599ff] text-white'
                : 'bg-[#f4f4f4] text-[#494949] hover:bg-gray-200',
            )}
          >
            {t(`filter.${key}`)}
          </button>
        )
      })}
    </div>
  )
}
